import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';
import { Container } from '@fiverr-private/layout_components';
import Badge from '../Badge';
import type { BadgeProps } from '../../types';
import SellerLevelDiamondIcon from '../helpers/SellerLevelDiamondIcon';

const SellerLevelTwoBadge = ({
  showTooltip = true,
  tooltipPosition = 'top',
  dataTestId,
  appendTooltipToBody,
  disableTooltipFlip,
}: BadgeProps) => (
  <Badge
    showTooltip={showTooltip}
    color="grey_1200"
    backgroundColor="transparent"
    tooltipContent={translate('badges.seller_level_two_badge.tooltip')}
    tooltipPosition={tooltipPosition}
    dataTestId={dataTestId}
    appendTooltipToBody={appendTooltipToBody}
    disableTooltipFlip={disableTooltipFlip}
    disablePadding={true}
  >
    <Container display="inlineFlex" gap="1" alignItems="center" justifyContent="center">
      <Typography>Level 2</Typography>
      <Container display="inlineFlex" gap="0.5">
        <SellerLevelDiamondIcon />
        <SellerLevelDiamondIcon />
        <SellerLevelDiamondIcon color="empty" />
      </Container>
    </Container>
  </Badge>
);

SellerLevelTwoBadge.displayName = 'SellerLevelTwoBadge';

export default SellerLevelTwoBadge;
